export class ClockTeamStat {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "TeamStat";
    this.scene = "Clock";
    this.data = [];
    this.page = 8095;
  }

  async preview({ options }) {
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "0026";
      }).value = "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "0027";
      }).value = options?.stat?.category;

      xml.payload.field.find((item) => {
        return item.attr.name === "0029";
      }).value = options?.stat?.home;

      xml.payload.field.find((item) => {
        return item.attr.name === "0028";
      }).value = options?.stat?.away;

      await this.updateVizPage({
        page: this.page,
        data: xml,
      }).catch((err) => {
        console.log(err);
      });
      this.sendAnimate({ page: this.page });
    } else {
      throw new Error("Could not update clock so did not animate it");
    }
  }
  animate({ options }) {
    this.sendAnimate({ page: this.page });
  }

  async animateOff({ options }) {
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "0026";
      }).value = "0";
      await this.updateVizPage({
        page: this.page,
        data: xml,
      }).catch((err) => {
        console.log(err);
      });
      this.sendAnimate({ page: this.page });
    } else {
      throw new Error("Could not update clock so did not animate it");
    }
  }

  update({ options }) {}
}
